import Vue from 'vue'
import App from './App.vue'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import VueFlashMessage from 'vue-flash-message';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheck, faEye, faEyeSlash} from "@fortawesome/free-solid-svg-icons";

library.add(faCheck, faEye, faEyeSlash);
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

Vue.component('vue-fontawesome', FontAwesomeIcon);
Vue.use(VueFlashMessage);
Vue.use(Buefy, {
  defaultIconComponent: 'vue-fontawesome',
  defaultIconPack: 'fas',
});

new Vue({
  render: h => h(App),
}).$mount('#app')
